import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useIsBrowser from 'hooks/useIsBrowser';
const useIsAdvancedSearch = () => {
  const isBrowser = useIsBrowser();
  const location = useLocation();
  const pathname = location?.pathname ?? "";
  const isAdvancedSearch = pathname === "/search/";
  return isBrowser ? isAdvancedSearch : false;
};
export default useIsAdvancedSearch;